import ColumnFilterContainer from '@/components/ColumnFilters/ColumnFilterContainer';
import type { ColumnFilterValue } from '@/models/flowFilter.type';
import { Checkbox, Stack } from '@mantine/core';

type SelectColumnFilterProps = {
  label: string;
  options: { value: string; label: string }[];
  value: ColumnFilterValue | undefined;
  onChange: (value: ColumnFilterValue | undefined) => void;
};

/** Filtre à choix multiples (une des valeurs cochées). */
const SelectColumnFilter = ({ label, options, value, onChange }: SelectColumnFilterProps) => {
  const selected = value?.kind === 'select' ? value.values : [];

  return (
    <ColumnFilterContainer onReset={() => onChange(undefined)}>
      <Checkbox.Group
        label={label}
        value={selected}
        onChange={values => onChange(values.length > 0 ? { kind: 'select', values } : undefined)}
      >
        <Stack gap="xs" mt="xs">
          {options.map(option => (
            <Checkbox key={option.value} value={option.value} label={option.label} />
          ))}
        </Stack>
      </Checkbox.Group>
    </ColumnFilterContainer>
  );
};

export default SelectColumnFilter;
